import React from "react";
import { useLocation } from "react-router-dom";

import "./Footer.scss";
import Logo from "../../assets/Logo1.png";
import FbIcon from "../../assets/FbIcon.png";
import TwitterIcon from "../../assets/TwitterIcon.png";
import YoutubeIcon from "../../assets/YoutubeIcon.png";
import LinkedinIcon from "../../assets/LinkedinIcon.png";
import SpotifyIcon from "../../assets/SpotifyIcon.png";
import MediumIcon from "../../assets/MediumIcon.png";

const Footer = () => {
	let location = useLocation();

	let footer = (
		<div
			className='footer'
			style={{
				marginBottom:
					location.pathname === "/" && window.innerWidth <= 425 && "4rem",
			}}
		>
			<div className='footer__logo'>
				<img src={Logo} alt='logo' />
			</div>
			<ul className='footer__lists'>
				<a
					href='https://classplusapp.com/aboutus.html'
					rel='noreferrer'
					target='_blank'
				>
					<li className='footer__list'>About us</li>
				</a>
				<a
					href='https://classplusapp.com/contactus.html'
					rel='noreferrer'
					target='_blank'
				>
					<li className='footer__list'>Contact us</li>
				</a>
				<a
					href='https://classplusapp.com/privacyPolicy.html'
					target='_blank'
					rel='noreferrer'
				>
					<li className='footer__list'>Privacy Policy</li>
				</a>
				<a
					href='https://classplusapp.com/termsconditions.html'
					target='_blank'
					rel='noreferrer'
				>
					<li className='footer__list'>Terms and Conditions</li>
				</a>
			</ul>
			<ul className='footer__social-media-lists'>
				<li className='footer__social-media-list'>
					<a
						href='https://www.facebook.com/classplusapp'
						rel='noreferrer'
						target='_blank'
					>
						<img src={FbIcon} alt='fb-icon' />
					</a>
				</li>
				<li className='footer__social-media-list'>
					<a href=' https://twitter.com/classplusapps' target='_blank'>
						<img src={TwitterIcon} alt='twitter-icon' />
					</a>
				</li>
				<li className='footer__social-media-list'>
					<a
						href=' https://www.linkedin.com/company/classplus/'
						target='_blank'
					>
						<img src={LinkedinIcon} alt='linkedin-icon' />
					</a>
				</li>

				<li className='footer__social-media-list'>
					<a
						href='https://classplus.medium.com'
						target='_blank'
						rel='noreferrer'
					>
						<img src={MediumIcon} alt='medium-icon' />
					</a>
				</li>
				<li className='footer__social-media-list'>
					<a
						href='https://open.spotify.com/show/5NFcpNr46n1BIzr358AoJx'
						target='_blank'
						rel='noreferrer'
					>
						<img src={SpotifyIcon} alt='spotify-icon' />
					</a>
				</li>
				<li className='footer__social-media-list'>
					<a
						href='https://www.youtube.com/channel/UCp0yDDnyu-C-0Bo_y1JbGtA'
						target='_blank'
						rel='noreferrer'
					>
						<img src={YoutubeIcon} alt='youtube-icon' />
					</a>
				</li>
			</ul>
		</div>
	);

	if (
		location.pathname === "/job-description" ||
		location.pathname === "/apply"
	) {
		footer = null;
	}

	return footer;
};

export default Footer;
